export const characterJson = [
  {
    name: 'Deadpool',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70183/conversions/Deadpool-67a9afebe635e-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70183/Deadpool-67a9afebe635e.jpg',
      id: 70185,
    },
    slug: 'deadpool',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Xiaorouseeu',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70522/conversions/Xiaorouseeu-67c303763aa6f-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70522/Xiaorouseeu-67c303763aa6f.jpg',
      id: 70542,
    },
    slug: 'xiaorouseeu',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Lana Rhoades',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70504/conversions/LanaRhoades-67c2f918c7935-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70504/LanaRhoades-67c2f918c7935.jpg',
      id: 70520,
    },
    slug: 'lana-rhoades',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Donald Trump',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70487/conversions/DonaldTrump-67c2f47041cdd-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70487/DonaldTrump-67c2f47041cdd.jpg',
      id: 70503,
    },
    slug: 'donald-trump',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Taylor Swift',
    image: {
      original:
        'https://prompz-bucket.s3.amazonaws.com/70146/TaylorSwift-679fd286d8565.jpg',
    },
    slug: 'taylor-swift',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Super Mario Style',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70217/conversions/Mariostyle-67b9e91f762f8-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70217/Mariostyle-67b9e91f762f8.jpg',
      id: 70219,
    },
    slug: 'super-mario-style',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Terminator T-800',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70205/conversions/TerminatorT-800-67b9e6519cd1b-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70205/TerminatorT-800-67b9e6519cd1b.jpg',
      id: 70207,
    },
    slug: 'terminator-t-800',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  // {
  //   name: 'Robert Francis Kennedy Jr.',
  //   image: {
  //     thumbnail:
  //       'https://prompz-bucket.s3.amazonaws.com/70513/conversions/RobertFrancisKennedyJr.-67c2fb87d411f-thumbnail.jpg',
  //     original:
  //       'https://prompz-bucket.s3.amazonaws.com/70513/RobertFrancisKennedyJr.-67c2fb87d411f.jpg',
  //     id: 70531,
  //   },
  //   slug: 'taylor-swift',
  //   ai_model: { name: 'Flux AI', slug: 'flux-ai' },
  //   ai_model_version_slug: 'lora',
  // },
];

export const stylesJson = [
  {
    name: 'Anime Style',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70193/conversions/AnimeStyle-67b9e19f59ebf-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70193/AnimeStyle-67b9e19f59ebf.jpg',
      id: 70195,
    },
    slug: 'anime-style',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },

  {
    name: '50s Illustration Style',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70229/conversions/50sIllustrationStyle-67b9ec6aac989-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70229/50sIllustrationStyle-67b9ec6aac989.jpg',
      id: 70231,
    },
    slug: '50s-illustration-style',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },

  {
    name: 'Xavier Duvet Style',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70293/conversions/XavierDuvetStyle-67ba06f472471-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70293/XavierDuvetStyle-67ba06f472471.jpg',
      id: 70295,
    },
    slug: 'xavier-duvet-style',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },

  {
    name: 'Retro neon style',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70389/conversions/Retroneonstyle-67bb5811c9d90-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70389/Retroneonstyle-67bb5811c9d90.jpg',
      id: 70395,
    },
    slug: 'retro-neon-style',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },

  // {
  //   name: 'Comic Book Page style (Anime + Manga + Western Comics)',
  //   image: {
  //     thumbnail:
  //       'https://prompz-bucket.s3.amazonaws.com/70441/conversions/ComicBookPagestyle%28Anime%2BManga%2BWesternComics%29-67c1ea768994c-thumbnail.jpg',
  //     original:
  //       'https://prompz-bucket.s3.amazonaws.com/70441/ComicBookPagestyle%28Anime%2BManga%2BWesternComics%29-67c1ea768994c.jpg',
  //     id: 70450,
  //   },
  //   slug: 'taylor-swift',
  //   ai_model: { name: 'Flux AI', slug: 'flux-ai' },
  //   ai_model_version_slug: 'lora',
  // },

  {
    name: 'Corporate Flat Vector Style',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70616/conversions/CorporateFlatVectorStyle-67d1a88a144e7-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70616/CorporateFlatVectorStyle-67d1a88a144e7.jpg',
      id: 70654,
    },
    slug: 'corporate-flat-vector-style',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },

  {
    name: '3D Illustration',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70669/conversions/3DIllustration-67d56d0c25d90-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70669/3DIllustration-67d56d0c25d90.jpg',
      id: 70717,
    },
    slug: '3d-illustration',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },

  {
    name: 'Pointillism Art style',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70269/conversions/PointillismArtstyle-67ba034fa8164-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70269/PointillismArtstyle-67ba034fa8164.jpg',
      id: 70271,
    },
    slug: 'pointillism-art-style',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
];

export const productJson = [
  {
    name: 'Tesla Optimus',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70249/conversions/TeslaOptimus-67ba00502a34a-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70249/TeslaOptimus-67ba00502a34a.jpg',
      id: 70251,
    },
    slug: 'tesla-optimus',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'My Ugly Christmas Sweater',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70281/conversions/MyUglyChristmasSweater-67ba050dcdaa8-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70281/MyUglyChristmasSweater-67ba050dcdaa8.jpg',
      id: 70283,
    },
    slug: 'my-ugly-christmas-sweater',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Delicious Food',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70603/conversions/DeliciousFood-67d1a3f2bf825-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70603/DeliciousFood-67d1a3f2bf825.jpg',
      id: 70639,
    },
    slug: 'delicious-food',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Bosch Professional Akku-Bohrhammer',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70531/conversions/BoschProfessionalAkku-Bohrhammer-67c31659a2b1f-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70531/BoschProfessionalAkku-Bohrhammer-67c31659a2b1f.jpg',
      id: 70553,
    },
    slug: 'bosch-professional-akku-bohrhammer',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Pixel game assets',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70571/conversions/Pixelgameassets-67c32507267ee-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70571/Pixelgameassets-67c32507267ee.jpg',
      id: 70601,
    },
    slug: 'pixel-game-assets',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Multiple Views',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70379/conversions/MultipleViews-67bb56bb97b86-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70379/MultipleViews-67bb56bb97b86.jpg',
      id: 70383,
    },
    slug: 'multiple-views',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Icon Maker',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70406/conversions/IconMaker-67c1e05cb2c45-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70406/IconMaker-67c1e05cb2c45.jpg',
      id: 70413,
    },
    slug: 'icon-maker',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  // {
  //   name: 'Office Interior Space',
  //   image: {
  //     thumbnail:
  //       'https://prompz-bucket.s3.amazonaws.com/70455/conversions/OfficeInteriorSpace-67c1ee7aa36c0-thumbnail.jpg',
  //     original:
  //       'https://prompz-bucket.s3.amazonaws.com/70455/OfficeInteriorSpace-67c1ee7aa36c0.jpg',
  //     id: 70467,
  //   },
  //   slug: 'taylor-swift',
  //   ai_model: { name: 'Flux AI', slug: 'flux-ai' },
  //   ai_model_version_slug: 'lora',
  // },
];

export const otherJson = [
  {
    name: 'Perfect Round Ass',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70420/conversions/PerfectRoundAss-67c1e439d9bfa-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70420/PerfectRoundAss-67c1e439d9bfa.jpg',
      id: 70429,
    },
    slug: 'perfect-round-ass',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Ass Grab',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70638/conversions/AssGrab-67d565d6962f7-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70638/AssGrab-67d565d6962f7.jpg',
      id: 70680,
    },
    slug: 'ass-grab',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
    tag_slugs: ['explicit', 'porn', 'sexy', 'adult-content']
  },
  {
    name: 'CCTV Store',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70590/conversions/CCTVStore-67d1a02d8074d-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70590/CCTVStore-67d1a02d8074d.jpg',
      id: 70624,
    },
    slug: 'cctv-store',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Female POV',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70660/conversions/FemalePOV-67d56b22ebc3a-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70660/FemalePOV-67d56b22ebc3a.jpg',
      id: 70706,
    },
    slug: 'female-pov',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Underboobs Clothing',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70687/conversions/UnderboobsClothing-67d570462fe3d-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70687/UnderboobsClothing-67d570462fe3d.jpg',
      id: 70739,
    },
    slug: 'underboobs-clothing',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: 'Movie Poster',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70558/conversions/MoviePoster-67c320869a1e7-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70558/MoviePoster-67c320869a1e7.jpg',
      id: 70586,
    },
    slug: 'movie-poster',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  {
    name: '1999 Digital Camera Style',
    image: {
      thumbnail:
        'https://prompz-bucket.s3.amazonaws.com/70549/conversions/1999DigitalCameraStyle-67c31e4c468f5-thumbnail.jpg',
      original:
        'https://prompz-bucket.s3.amazonaws.com/70549/1999DigitalCameraStyle-67c31e4c468f5.jpg',
      id: 70575,
    },
    slug: '1999-digital-camera-style',
    ai_model: { name: 'Flux AI', slug: 'flux-ai' },
    ai_model_version_slug: 'lora',
  },
  // {
  //   name: 'Latte Art',
  //   image: {
  //     thumbnail:
  //       'https://prompz-bucket.s3.amazonaws.com/70239/conversions/LatteArt-67b9ef2043b42-thumbnail.jpg',
  //     original:
  //       'https://prompz-bucket.s3.amazonaws.com/70239/LatteArt-67b9ef2043b42.jpg',
  //     id: 70241,
  //   },
  //   slug: 'taylor-swift',
  //   ai_model: { name: 'Flux AI', slug: 'flux-ai' },
  //   ai_model_version_slug: 'lora',
  // },
];
